// extracted by mini-css-extract-plugin
export default {"dashboardwrapper":"Dashboard_dashboardwrapper__Dlh-e","dashboardmain":"Dashboard_dashboardmain__i+HRt","link":"Dashboard_link__fuUjV"};